import { useEffect, useState } from "react"
import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

interface IAppState {
  tokens: Record<string, string | undefined>

  setToken: (token_id: string, value: string) => void
}

const useAppStore = create(
  persist<IAppState>(
    (set) => ({
      tokens: {},

      setToken: (token_id: string, value: string) =>
        set((state) => ({
          tokens: {
            ...state.tokens,
            [token_id]: value,
          },
        })),
    }),
    {
      name: "hub-store",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)

const useHydrated = () => {
  const [hydrated, setHydrated] = useState(useAppStore.persist.hasHydrated())

  useEffect(() => {
    const unsubscribe = useAppStore.persist.onFinishHydration(() => {
      setHydrated(true)
    })
    return unsubscribe
  }, [])

  return hydrated
}

export { useAppStore, useHydrated }
